import { Component,Input,OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { scheduleService } from '../../service/schedule.service';
import { facultyService } from '../../service/faculty.service';
import { sessionService } from '../../service/session.service';
import {commonService} from "../../service/common.service";
import {contentService} from "../../service/content.service";
import { Router,ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import {Globals} from '../.././globals';

@Component({
  selector: 'app-rank-predictor',
  templateUrl: './rank-predictor.component.html',
  styleUrls: ['./rank-predictor.component.css'],
  providers:[scheduleService,facultyService,sessionService,contentService]
})
export class RankPredictorComponent implements OnInit {
  GATE2019={'title':'GATE2019','desciprtion':'desciprtion'};

  rankpredictor:any;

  isError=false;
  msg:any;
  ranklist:any;
  isErrorExcel=false;
  isSuccessExcel=false;
  isSuccess=false;
  totalrow:number;
  searchtxt:string;
  notfound=false;
  iserrorlog=false;
  //sortedData;
    pageSize = 10;
    currentPage = 0;
    totalSize = 0;
    start=0;
    end=10;
    msgclass="success";
    user:any;
    pageEvent:any;
  constructor(private _content:contentService,public router: Router,private commonService:commonService,private _schedule:scheduleService,private _session:sessionService,private _faculty:facultyService,private frmBuilder: FormBuilder,private route: ActivatedRoute,private global:Globals) { 
    
  
    this.commonService.profile.subscribe((data:any)=>{
      if(data){
      this.user=data; 
     
      }else{
        this.user={};
      } 

    });
    
    }

  ngOnInit() {
        this.getrankplist();
  }

  getrankplist(){
    //console.log('sdfsdfsd');
    this._content.rankfrontplist({0:this.start,1:this.end,2:this.searchtxt,3:(this.user)?this.user.id:''}).subscribe((data : any)=>{
      if(data.error==0){ 
        //console.log(data.results.rows);
        this.ranklist = data.results.rows;   
              this.totalrow = data.results.count;
              if(this.totalrow==0){
                this.notfound=true;
              }else{
                this.notfound=false;
              }
        
        //console.log(this.courselist);
      }else{
        if(data.message=="Failed to authenticate token."){
          this.router.navigate(['/admin']);
        }else{
         this.msg = data.message;
         this.isError = true;
        }
      }
},
 (error : HttpErrorResponse)=>{
   this.isError = true;
   this.msg="internal server error!";
 });
}

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/rank-predictor/rank-predictor.component.ts